import { Injectable, OnInit } from "@angular/core";
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from "@angular/common/http";
import { User } from "src/app/models/user";
import { HttpService } from "../../assetModule/shared/services/http.service";
import { UserRestriction } from "src/app/models/UserRestriction";
import { Observable } from "rxjs";
import { ApiDocumentation } from "src/app/models/ApiDocumentation";

@Injectable({
  providedIn: "root"
})
export class UserService implements OnInit {
  loggendInUser = new User();

  constructor(private http: HttpClient, private httpService: HttpService) { }

  ngOnInit() {
    if (sessionStorage.getItem("userinfo")) {
      this.loggendInUser = JSON.parse(sessionStorage.getItem("userinfo"));
    }
  }

  loginUser() {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('applicationName', 'VAL Web App');
    if (this.httpService.basePath.indexOf('localhost') > -1 || this.httpService.basePath.indexOf('inghman000072ws') > -1)
      return this.http.get(`${this.httpService.basePath}/user/login/local`, { headers });
    return this.http.get(`${this.httpService.basePath}/user/login`, { headers });
  }

  updateUserSettings(loggedInUser: User) {
    return this.http.put<User>(`${this.httpService.basePath}/user/updateUserSettings`, loggedInUser);
  }

  termsAndConditions(userEmailId) {
    return this.http.post(`${this.httpService.basePath}/user/terms/${userEmailId}`, null);
  }

  updateWizardStatus(userEmailId) {
    return this.http.post(`${this.httpService.basePath}/user/wizard/${userEmailId}`, null, { responseType: 'text' as 'json' });
  }

  getUser() {
    this.http
      .get(`${this.httpService.basePath}/user/getUserInfo/`, { responseType: "text", observe: "response" })
      .subscribe(
        (res: HttpResponse<any>) => {
          console.log(res.headers.keys());
          console.log(res);
        },
        err => {
          console.error(err);
        }
      );
  }

  submitFeedback(feedback) {
    return this.http.post(`${this.httpService.basePath}/user/feedback`, feedback);
  }

  setRating(rating, asset_id: string) {
    return this.http.post(`${this.httpService.basePath}/asset/rating/${asset_id}`, rating);
  }

  getUserStatistics(userEmailId = '') {
    return this.http.get(`${this.httpService.basePath}/user/userStatistics/${userEmailId}`);
  }

  getAllUser() {
    return this.http.get(`${this.httpService.basePath}/user/getallusers/${this.loggendInUser.userEmailId}`);
  }

  moveUser(responseParam: any) {
    return this.http.put(`${this.httpService.basePath}/user/changerole/${this.loggendInUser.userEmailId}`, responseParam);
  }

  getHighRatedAsset(userEmailId) {
    return this.http.get(`${this.httpService.basePath}/user/gethighratedasset/${userEmailId}`);
  }

  getAllUploadedAsset(userEmailId) {
    return this.http.get(`${this.httpService.basePath}/user/getalluploadedasset/${userEmailId}`);
  }

  updateUserRestriction(userRestriction: UserRestriction) {
    return this.http.put(`${this.httpService.basePath}/user/updateUserRestrictions/${this.loggendInUser.userEmailId}`, userRestriction);
  }

  updateUserInfo(requestParam: any) {
    return this.http.put(`${this.httpService.basePath}/user/updateDetails`, requestParam);
  }

  getAuditDetails(userEmailId: string) {
    return this.http.get(`${this.httpService.basePath}/user/audit/${userEmailId}`);
  }

  getSelectedAuditDetails(userEmailId: string, userAuditEmailId: string) {
    return this.http.get(`${this.httpService.basePath}/user/audit/${userEmailId}/${userAuditEmailId}`);
  }

  getExternalUsers(applicationID: string) {
    return this.http.get(`${this.httpService.basePath}/user/external-user/${applicationID}`);
  }

  getExternalApplications(): Observable<any[]> {
    return this.http.get<any[]>(`${this.httpService.basePath}/user/applications`);
  }

  addExternalUsers(user: any) {
    return this.http.post(`${this.httpService.basePath}/user/external-user`, user);
  }

  deleteExternalUser(user: string, application: string) {
    return this.http.delete(`${this.httpService.basePath}/user/external-user/${user}/${application}`);
  }

  modifyExternalUser(user: any) {
    return this.http.patch(`${this.httpService.basePath}/user/external-user`, user);
  }

  getApiDocumentation(userEmailId) {
    return this.http.get<Array<ApiDocumentation>>(`${this.httpService.basePath}/documentation/${userEmailId}`);
  }

  uploadUserProfileImage(userEmailId, formData: FormData) {
    return this.http.put(`${this.httpService.basePath}/user/upload/${userEmailId}`, formData);
  }

  getUserGroupsByApplicationId(userEmailId: string, applicationId: string): Observable<any[]> {
    const options = {
      headers: new HttpHeaders({ 'userEmailId': userEmailId, 'appId': applicationId }),
    };
    return this.http.get<any>(`${this.httpService.basePath}/user/groups`, options);
  }

  fetchUserProfileImage(userEmailId: string) {
    return this.http.get(`${this.httpService.basePath}/user/profileimage/${userEmailId}`, { responseType: 'text' });
  }

  deleteUserProfileImage(userEmailId: string) {
    return this.http.delete(`${this.httpService.basePath}/user/profileimage/${userEmailId}`);
  }

  deleteUserGroup(userEmailId, groupId, appName) {
    const options: any = {
      headers: new HttpHeaders({ 'userEmailId': userEmailId, 'applicationName': appName }),
      responseType: "text"
    };
    return this.http.delete(`${this.httpService.basePath}/user/groups/${groupId}`, options);
  }

  fetchUserCount(userEmailId, groupId, appName): Observable<any>{
    const options: any = {
      headers: new HttpHeaders({ 'userEmailId': userEmailId, 'applicationName': appName })
    };
    return this.http.get(`${this.httpService.basePath}/user/groups/${groupId}`, options);
  }

  modifyUserGroup(userEmailId, appName, groupToModify) {
    const options: any = {
      headers: new HttpHeaders({ 'userEmailId': userEmailId, 'applicationName': appName }),
      responseType: "text"
    };
    return this.http.post(`${this.httpService.basePath}/user/groups/${groupToModify._id}`, groupToModify, options);
  }

  addNewUserGroup(userEmailId, userGroup, appName) {
    const options: any = {
      headers: new HttpHeaders({ 'userEmailId': userEmailId, 'applicationName': appName }),
      responseType: "text"
    };
    return this.http.post(`${this.httpService.basePath}/user/groups`, userGroup, options);
  }

  getAllExternalApplication(userEmailId, appName){
    const options: any = {
      headers : new HttpHeaders({ 'userEmailId': userEmailId, 'applicationName': appName }),
      responseType: "text"
    };

    return this.http.get(`${this.httpService.basePath}/user/external-app`, options);
  }

  addExternalApplication(userEmailId, appName, ExternalAppName){
    const options: any = {
      headers: new HttpHeaders({ 'userEmailId': userEmailId, 'applicationName': appName }),
      responseType: "text"
    };
    return this.http.post(`${this.httpService.basePath}/user/external-app`, ExternalAppName, options);
  }

  requestUnityPlugin(unityPluginParams, appName, userEmailId)
  {
    const options: any = {
      headers: new HttpHeaders({ 'userEmailId': userEmailId, 'applicationName': appName }),
      responseType: "arraybuffer"
    };
    return this.http.post(`${this.httpService.basePath}/user/unityplugin`,unityPluginParams, options);
  }

  addConsumerApplication(userEmailId, appName, selectedConsumerApp, providerApplicationId)
  {
    const options: any = {
      headers: new HttpHeaders({ 'userEmailId': userEmailId, 'applicationName': appName })
    };
    return this.http.post<boolean>(`${this.httpService.basePath}/user/addConsumers/` + providerApplicationId ,selectedConsumerApp, options);
  }

}
